import { render, staticRenderFns } from "./JoinButton.vue?vue&type=template&id=813e0f2e&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JoinButton.vue"
export default component.exports